import { useSelector } from "react-redux";
import { VariablesState } from "./slice";

export const useVariablesState = () => {
    return useSelector((state: { variables: VariablesState }) => state);
};
